import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { FormaPagamentoSelectComponent } from './forma-pagamento-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        FormaPagamentoSelectComponent
    ],
    exports: [
        FormaPagamentoSelectComponent
    ]
})
export class FormaPagamentoSelectModule { }
